export enum SignInChallengeType {
  NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED',
  TERMS_AND_PRIVACY_POLICY_CHALLENGE = 'TERMS_AND_PRIVACY_POLICY_CHALLENGE',
  MFA_SETUP = 'MFA_SETUP',
  SOFTWARE_TOKEN_MFA = 'SOFTWARE_TOKEN_MFA',
}
